// extracted by mini-css-extract-plugin
module.exports = {"main":"error_main__yqKJ5","mainDiv":"error_mainDiv__B8goP"};